import React, { memo, useContext, useEffect, useRef } from 'react';
import loadable from '@loadable/component';
import { Context } from '../../context/AppContext';

const NotificationBarContent = loadable(() => import('./NotificationBar'));

const NotificationBar = props => {
  const {
    notificationBar: { setNotificationBar, params },
  } = useContext(Context);

  const timerRef = useRef();
  const { show, message, buttons, duration } = props.params || params || {};

  useEffect(() => {
    if (show) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        setNotificationBar({ show: false });
      }, duration);
    }
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [show, duration]);

  return show ? (
    <NotificationBarContent
      setNotificationBar={setNotificationBar}
      message={message}
      buttons={buttons}
    />
  ) : (
    ''
  );
};

export default NotificationBar;
